import './Footer.css'

const Footer = () => {
  const year = new Date();
  const currentYr = year.getFullYear();
  return (
    <footer className='footer'>
      <br />
      <div>
        <div className="footer-parent-div">
          <div className="footer-div-first">
            <img src="images/logo.png" alt="logo"/>
            <p>WeLearn - Whether you need to learn or to share what you know, you've come to the perfect locations. As a worldwide objective for web based learning, we interface individuals through information. So let's Learn Together!</p>
            <div className='copyright'>&copy; Tania Riaz {currentYr}</div>
          </div>

          <div className="footer-div-third">
            <h2 className='Contact-title'>Contact</h2>
            <p>Phone: <a href="tel:+46734649572">+46734649572</a></p>
            <p>Address: Malmö Sweden</p>
            <p>Email: <a href = "mailto: infoitwiz336@gmail.com"><span className='it-wiz-span'>(infoitwiz336@gmail.com)</span></a></p>      
          </div>
              
        </div>
      
      </div>
      
    </footer>
  )
}

export default Footer